import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { inaccessibleLayoutSessionAtom, inaccessibleLayoutSessionPagesAtom } from '../../../../atoms/session-atoms';
import { useGenericElement } from '../../../../hooks/use-generic-element';
export const useSyncSessionLayout = (failedElements, pageId) => {
  const setSessionComponents = useSetAtom(inaccessibleLayoutSessionAtom);
  const setInaccessibleLayoutPages = useSetAtom(inaccessibleLayoutSessionPagesAtom);
  const {
    getComponent
  } = useGenericElement({
    getComponentStyleSource: () => 'unknown',
    pageId: '',
    unknownValue: 'unknown'
  });
  useEffect(() => {
    setInaccessibleLayoutPages(prev => {
      if (!prev.includes(pageId)) {
        return [...prev, pageId];
      }
      return prev;
    });
  }, [pageId, setInaccessibleLayoutPages]);
  useEffect(() => {
    const updateSessionComponents = async () => {
      let currentPageComponents = [];
      setSessionComponents(prev => {
        currentPageComponents = prev[pageId] || [];
        return prev;
      });
      const currentPageComponentsIds = new Set(currentPageComponents.map(el => el.id));
      const failedElementsMap = new Map(failedElements.map(el => [el.id, el]));
      const updatedElements = currentPageComponents.map(sessionComponent => {
        const matchedElement = failedElementsMap.get(sessionComponent.id);
        return {
          ...sessionComponent,
          ...(matchedElement && {
            label: matchedElement.label,
            layoutValue: matchedElement.layoutValue,
            widgetId: matchedElement.widgetId
          }),
          isFixed: !failedElementsMap.has(sessionComponent.id)
        };
      });
      const newElementsPromises = failedElements.filter(_ref => {
        let {
          id
        } = _ref;
        return !currentPageComponentsIds.has(id);
      }).map(async element => {
        const component = getComponent(element.id);
        return component ? {
          ...element,
          ...component
        } : null;
      });
      const newElementsResults = await Promise.all(newElementsPromises);
      const newElements = newElementsResults.filter(el => el !== null);
      setSessionComponents(prev => {
        const isSameState = updatedElements.length === currentPageComponents.length && updatedElements.every((el, index) => el.id === currentPageComponents[index].id && el.isFixed === currentPageComponents[index].isFixed && el.layoutValue === currentPageComponents[index].layoutValue) && newElements.length === 0;
        if (isSameState) {
          return prev;
        }
        return {
          ...prev,
          [pageId]: [...updatedElements, ...newElements]
        };
      });
    };
    updateSessionComponents();
  }, [failedElements, getComponent, pageId, setSessionComponents]);
};
//# sourceMappingURL=use-sync-session-layout.js.map